import { c as _c } from "react/compiler-runtime";
import { Button, IconButton, useTranslationContext } from 'platform/components';
import { SECTION_BORDER_BOTTOM } from '../../constants/borderStyles';
import { SELECTION_TEST_ID_PREFIX } from '../../constants/selectionColumn';
import { ActionDefinitionObject } from '../../types/ActionDefinition';
interface BulkActionsBarProps {
  selectedCount: number;
  bulkActions: ActionDefinitionObject;
  onDeselectAll: () => void;
  onBulkAction: (actionKey: string) => void;
  disableAllActions?: boolean;
  isLoading?: boolean;
}

/**
 * Shows: selected count text | bulk action buttons | deselect IconButton.
 *
 * When no bulk actions are available, degrades gracefully to count + deselect only.
 */
export function BulkActionsBar(props) {
  const $ = _c(18);
  const t = useTranslationContext();
  let t0;
  if ($[0] !== props.bulkActions) {
    t0 = Object.entries(props.bulkActions);
    $[0] = props.bulkActions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const actionEntries = t0;
  const t1 = String(props.selectedCount);
  let t2;
  if ($[2] !== t || $[3] !== t1) {
    t2 = t("page.datagrid.labels.numberOfSelectedRows", {
      selectedRows: t1
    });
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span>{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== actionEntries || $[8] !== props) {
    t4 = actionEntries.map(t5 => {
      const [actionKey, actionDef] = t5;
      return <Button key={actionKey} variant="secondary" size="small" title={actionDef.title} leftIcon={actionDef.icon.value} onClick={() => props.onBulkAction(actionKey)} isDisabled={props.disableAllActions || props.isLoading} isLoading={props.isLoading} data-testid={`${SELECTION_TEST_ID_PREFIX}-bulk-${actionKey}`} />;
    });
    $[7] = actionEntries;
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.onDeselectAll) {
    t5 = <IconButton icon="navigation/close" size="small" priority="secondary" onClick={props.onDeselectAll} data-testid={`${SELECTION_TEST_ID_PREFIX}-deselect-all`} />;
    $[10] = props.onDeselectAll;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex items-center gap-1">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div className="flex items-center justify-between px-2 py-2 bg-gray-50 text-sm text-gray-600 flex-shrink-0" style={SECTION_BORDER_BOTTOM}>{t3}{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}